// src/views/litellm/AiUsagePage.jsx
import React from "react";
import { useSearchParams } from "react-router-dom";
import { HeaderPortal } from "../../components/ui-components/HeaderSlot.jsx";
import RealtimeAIMonitorPage from "./RealtimeAIMonitorPage";
import TrendsView from "./trends/TrendsView";

// AI Usage is one page in two modes, not two pages.
//
//   Trends — historical AI consumption analysis (the default, for finance).
//   Live   — what is consuming AI right now (the original operational screen).
//
// The split is forced by the data: Live reads a Postgres buffer pruned to
// roughly seven days, so it structurally cannot answer a 30/90/365-day
// question no matter how long its date selector gets.
//
// Why a segmented control rather than a nested tab strip: TopBar renders one
// native strip per route, and a page-provided strip lands on that SAME row, so
// nesting would read as one flat four-tab row. These are modes of one page, so
// a mode switch is the honest control.
const MODES = [
  { id: "trends", label: "Trends" },
  { id: "live", label: "Live" },
];

export default function AiUsagePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get("view");
  const view = MODES.some((m) => m.id === requested) ? requested : "trends";

  const setView = (next) => {
    const merged = new URLSearchParams(searchParams);
    if (next === "trends") merged.delete("view");
    else merged.set("view", next);
    setSearchParams(merged, { replace: true });
  };

  return (
    <>
      <HeaderPortal slot="row2-left">
        <div role="tablist" aria-label="AI usage mode" className="flex items-center gap-0.5 rounded-ctrl bg-surface-2 p-0.5">
          {MODES.map((m) => (
            <button
              key={m.id}
              type="button"
              role="tab"
              aria-selected={view === m.id}
              onClick={() => setView(m.id)}
              style={{ height: 28 }}
              className={`box-border rounded-ctrl px-3 text-[13px] font-semibold transition-colors ${
                view === m.id ? "bg-card text-text shadow-sm" : "text-text-3 hover:text-text-2"
              }`}
            >
              {m.label}
            </button>
          ))}
        </div>
      </HeaderPortal>

      {view === "live" ? <RealtimeAIMonitorPage /> : <TrendsView />}
    </>
  );
}
